import React, { useState, useEffect } from "react";
import useStyles from "../../partner/style";
import useStylesTable from "../../settings/styles";
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from "@material-ui/core/Checkbox";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    TextField
} from "@material-ui/core";

const SelectServicesAndDays = ({ text, setValue, services, menuProps, isEnable, isRequired, addValues, key, keyTable }) => {
    const classes = useStyles();
    const classesTable = useStylesTable();
    const isAllSelected = services.length > 0 && text.text.length === services.length;
    const [servicesSelected, setServicesSelected] = useState([]);
    const [servicesAndDays, setServicesAndDays] = useState([]);

    useEffect(() => {
        const servicesListText = [];
        const servicesList = [];

        text.text.map((option) => {
            var servicesItem = {
                "serviceName": option.serviceName,
                "numberOfDays": option.numberOfDays,
            };

            servicesListText.push(option.serviceName);
            servicesList.push(servicesItem);
        });

        setServicesSelected(servicesListText);
        setServicesAndDays(servicesList);
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;

        if (value[value.length - 1] === "all") {
            const allList = [];
            const servicesList = [];

            services.map((option) => {
                allList.push(option.serviceName);

                var servicesItem = {
                    "serviceName": option.serviceName,
                    "numberOfDays": null,
                };

                servicesList.push(servicesItem);
            });

            setServicesSelected(servicesSelected.length === services.length ? [] : allList);
            setServicesAndDays(servicesSelected.length === services.length ? [] : servicesList);
            addValues(servicesSelected.length === services.length ? [] : servicesList);
            setValue({
                ...text, text: text.text.length === services.length ? [] : allList,
                valid: text.text.length === services.length ? 'false' : 'true'
            });
            return;
        }
        if (value != '') {
            const servicesList = [];

            services.map((option) => {
                for (var i = 0; i < value.length; i++) {
                    var name = value[i];
                    if (option.serviceName == name) {

                        var servicesItem = {
                            "serviceName": name,
                            "numberOfDays": null,
                        };

                        servicesList.push(servicesItem);
                    }
                }

                setServicesAndDays(servicesList);
                addValues(servicesList);
            });

            setServicesSelected(value);
            setValue({ ...text, text: value, valid: 'true' });
            return;
        }
        setServicesSelected(value);
        setValue({ ...text, text: value, valid: 'false' });
        setServicesAndDays([]);
        addValues([]);
    }

    const onChange = (property) => (event) => {
        var value = event.target.value;

        servicesAndDays.map((item) => {
            if (item.serviceName == property) {
                var index = servicesAndDays.indexOf(item);

                if (value < 1) {
                    value = 1;
                } else if (value > 7) {
                    value = 7;
                }

                var servicesItem = {
                    "serviceName": item.serviceName,
                    "numberOfDays": value,
                };

                const allList = servicesAndDays;
                allList[index] = servicesItem;
                setServicesAndDays(allList);
                addValues(allList);
            }
        });
    }

    return (
        <div>
            <div className={classes.divLabel}>
                <p className={classes.label} >{"Servicios"}</p>
                {isRequired ? (
                    <p style={{ fontSize: 26, color: "#FF0000" }}>*</p>
                ) : (
                    <></>
                )}
            </div>

            <FormControl className={classes.formControl}>
                <Select
                    key={key}
                    labelId="mutiple-select-label"
                    multiple
                    value={servicesSelected}
                    onChange={handleChange}
                    renderValue={(selected) => selected.join(", ")}
                    MenuProps={menuProps}
                    disabled={isEnable ?? false}
                    style={{ color: "#FFFFFF" }}
                >
                    <MenuItem
                        value="all"
                        classes={{
                            root: isAllSelected ? classes.selectedAll : ""
                        }}
                    >
                        <ListItemIcon>
                            <Checkbox
                                classes={{ indeterminate: classes.indeterminateColor }}
                                checked={isAllSelected}
                                indeterminate={
                                    servicesSelected.length > 0 && servicesSelected.length < services.length
                                }
                            />
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.selectAllText }}
                            primary="Seleccionar todos"
                        />
                    </MenuItem>
                    {services.map((option) => (
                        <MenuItem key={option.serviceName} value={option.serviceName}>
                            <ListItemIcon>
                                <Checkbox checked={servicesSelected.indexOf(option.serviceName) > -1} />
                            </ListItemIcon>
                            <ListItemText primary={option.serviceName} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <br /><br />

            <div style={{ backgroundColor: "#FFFFFF", borderRadius: '4px', }}>
                <Table className="mb-0" key={keyTable}>
                    <TableHead>
                        <TableRow className={classesTable.tableServices} >
                            <TableCell>SERVICIO</TableCell>
                            <TableCell>NÚM. DE DÍAS</TableCell>
                            {/*{keys.map(key => (
                            <TableCell key={key}>{key}</TableCell>
                        ))}*/}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {servicesAndDays.map((item) => (
                            <TableRow key={"id"}>
                                <TableCell className={classesTable.tableServicesTextStyle} >{item.serviceName}</TableCell>

                                <TableCell className={classesTable.tableServicesTextStyle} >
                                    <TextField
                                        InputProps={{
                                            classes: {
                                                focused: classes.textBorderMembership,
                                                input: classes.inputMembership,
                                            },
                                            inputProps: {
                                                max: 7, min: 1
                                            }
                                        }}
                                        disabled={isEnable ?? false}
                                        value={item.numberOfDays}
                                        onChange={onChange(item.serviceName).bind(this)}
                                        placeholder={"7"}
                                        type={"number"}
                                        onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        style={{ width: '100%' }}
                                        inputStyle={{ width: '100%' }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>

        </div>
    );
}

export default SelectServicesAndDays;